angular.module('MW.InsDashboard.SocialReachWidget.GroupedBarChartDataFormatter', [
    'DashboardChartConfigService',
    'MW.Framework.TranslationService',
    'MW.InsDashboard.InsWidgetConfigService',
    'MW.Framework.CoreUserService',
    'MW.InsDashboard.SocialReachWidget.SocialReachChartDataFormattingService',
    'MW.InsDashboard.SocialReachWidget.SocialReachTooltipRenderer'
]).constant('GroupedBarSourceIndex', {
    YOUTUBE_INDEX: 0,
    TWITTER_INDEX: 1,
    FACEBOOK_INDEX: 2
}).factory('GroupedBarChartTooltipHandler', [
    'GroupedBarSourceIndex',
    'SocialReachTooltipOptions',
    'SocialReachTooltipRenderer',
    function (
        GroupedBarSourceIndex,
        SocialReachToolTipOptions,
        SocialReachTooltipRenderer
    ) {
        function getDataByIndex(series, xAxisIndex, seriesIndex) {
            var seriesDataIndex = series[seriesIndex].xData.indexOf(xAxisIndex);
            if (seriesDataIndex > -1) {
                return series[seriesIndex].yData[seriesDataIndex];
            }
            return 0;
        }

        function calculatePercentage(total, onePart) {
            return (onePart / total) * 100;
        }

        return {
            createGroupedBarChartTooltipHandler: function (dateFrom, dateTo, searchName) {
                function groupedBarChartTooltipHandler(event) {
                    var youTubePercentage,
                        twitterPercentage,
                        facebookPercentage;


                    var categoryName = this.x;
                    var xAxisIndex = event.chart.xAxis[0].categories.indexOf(categoryName);

                    var youTubeCount = getDataByIndex(event.chart.series, xAxisIndex, GroupedBarSourceIndex.YOUTUBE_INDEX);
                    var twitterCount = getDataByIndex(event.chart.series, xAxisIndex, GroupedBarSourceIndex.TWITTER_INDEX);
                    var facebookCount = getDataByIndex(event.chart.series, xAxisIndex, GroupedBarSourceIndex.FACEBOOK_INDEX);
                    var total = youTubeCount + twitterCount + facebookCount;

                    if(total > 0) {
                        youTubePercentage = calculatePercentage(total, youTubeCount);
                        twitterPercentage = calculatePercentage(total, twitterCount);
                        facebookPercentage = calculatePercentage(total, facebookCount);
                    }

                    var socialReachTooltipOptions = new SocialReachToolTipOptions({
                        showChange: xAxisIndex !== 0,
                        change: this.point.change,
                        dateFrom: dateFrom,
                        dateTo: dateTo,
                        searchName: searchName,
                        youTubeCount: youTubeCount,
                        youTubePercentage: youTubePercentage,
                        twitterCount: twitterCount,
                        twitterPercentage: twitterPercentage,
                        facebookCount: facebookCount,
                        facebookPercentage: facebookPercentage,
                        totalCount: total
                    });

                    return SocialReachTooltipRenderer.render(socialReachTooltipOptions);
                }
                return groupedBarChartTooltipHandler;
            }
        };
    }
]).service('GroupedBarChartDataFormatter', [
    'DashboardChartConfigService',
    'translationService',
    'InsWidgetConfigService',
    'CoreUserService',
    'SocialReachChartDataFormattingService',
    'GroupedBarChartTooltipHandler',
    function (DashboardChartConfigService, translationService, InsWidgetConfigService, CoreUserService, SocialReachChartDataFormattingService, GroupedBarChartTooltipHandler) {
        return {
            getXAxisConfigs: function getXAxisConfigs(isMaximized, labelVisibility, percentageMode, tickPositions, dateCategories, totalArray) {
                var xAxisConfig = [
                    {
                        max: tickPositions.length - 1,
                        min: 0,
                        lineColor: '#eee',
                        tickColor: '#eee',
                        startOnTick: false,
                        tickmarkPlacement: 'on',
                        type: 'category',
                        categories: dateCategories,
                        minPadding: 0,
                        tickLength: 5,
                        labels: {
                            y: 14,
                            enabled: false
                        }
                    },
                    {
                        max: tickPositions.length - 1,
                        min: 0,
                        lineWidth: 0,
                        type: 'category',
                        tickColor: '#ffffff',
                        tickPositions: !isMaximized ? [0, tickPositions.length - 1] : tickPositions,
                        tickLength: 5,
                        categories: dateCategories,
                        linkedTo: 0,
                        labels: {
                            y: 14,
                            overflow: 'justify',
                            style: {
                                color: '#888',
                                font: '11px "Helvetica Neue", Verdana, sans-serif',
                                fontWeight: '500'
                            }
                        }
                    }
                ];

                if(SocialReachChartDataFormattingService.areTotalsLabelsVisible(labelVisibility, percentageMode)) {
                    xAxisConfig.push({
                        max: tickPositions.length - 1,
                        min: 0,
                        lineWidth: 0,
                        type: 'category',
                        tickLength: 0,
                        tickPositions: tickPositions,
                        categories: totalArray,
                        linkedTo: 0,
                        opposite: true,
                        labels: {
                            y: -14,
                            overflow: 'justify',
                            autoRotation: [-90],
                            style: {
                                color: '#000',
                                fontWeight: 'bold'
                            }
                        }
                    });
                }

                return xAxisConfig;
            },
            formatChartData: function formatChartData(scope, socialReachData, dateStart, dateEnd, granularity) {
                var change,
                    chartScale,
                    chartType,
                    dateCategories,
                    youtubeData,
                    facebookData,
                    twitterData,
                    epochMoment,
                    facebookDataPoint,
                    index,
                    percentageMode,
                    previousTotal,
                    seriesArray,
                    tickPositions,
                    timezone,
                    tooltipHandler,
                    total,
                    totalFacebookCount,
                    totalTwitterCount,
                    totalYoutubeCount,
                    twitterDataPoint,
                    youtubeDataPoint,
                    totalArray;

                tooltipHandler = GroupedBarChartTooltipHandler.createGroupedBarChartTooltipHandler(
                    dateStart,
                    dateEnd,
                    scope.inputs[0].name);
                percentageMode = scope.widget.settings.chart.percentageMode;
                chartScale = scope.widget.getChartScaleProperty();
                chartType = SocialReachChartDataFormattingService.getChartType(percentageMode, chartScale);
                dateCategories = SocialReachChartDataFormattingService.getDateCategories(socialReachData.data.views.yt_views.statistics, dateStart, dateEnd, granularity);
                youtubeData = {
                    name: SocialReachChartDataFormattingService.sourceSettings.YouTube.name,
                    data: [],
                    showInLegend: false,
                    linkedTo: SocialReachChartDataFormattingService.sourceSettings.YouTube.id
                };
                facebookData = {
                    name: SocialReachChartDataFormattingService.sourceSettings.Facebook.name,
                    data: [],
                    showInLegend: false,
                    linkedTo: SocialReachChartDataFormattingService.sourceSettings.Facebook.id
                };
                twitterData = {
                    name: SocialReachChartDataFormattingService.sourceSettings.Twitter.name,
                    data: [],
                    showInLegend: false,
                    linkedTo: SocialReachChartDataFormattingService.sourceSettings.Twitter.id
                };
                index = 0;
                previousTotal = 0;
                tickPositions = SocialReachChartDataFormattingService.createTickPositions(socialReachData.data.views.yt_views.statistics);
                timezone = CoreUserService.getTimezone();
                totalArray = [];

                for (var epoch in socialReachData.data.views.yt_views.statistics) {
                    if(!socialReachData.data.views.yt_views.statistics.hasOwnProperty(epoch)) {
                        continue;
                    }
                    totalFacebookCount = socialReachData.data.views.fb_totals.statistics[epoch].SUM;
                    totalTwitterCount = socialReachData.data.views.tw_followers.statistics[epoch].SUM;
                    totalYoutubeCount = socialReachData.data.views.yt_views.statistics[epoch].SUM;
                    total = (totalFacebookCount + totalTwitterCount + totalYoutubeCount);

                    totalArray.push(SocialReachChartDataFormattingService.formatFixedPrecisionDataLabels(total, scope.isMaximized));

                    change = SocialReachChartDataFormattingService.calculateChange(previousTotal, total);
                    epochMoment = moment(parseInt(epoch)).tz(timezone);

                    youtubeDataPoint = SocialReachChartDataFormattingService.calculateDataPoint(SocialReachChartDataFormattingService.sourceSettings.YouTube, totalYoutubeCount, index, epochMoment, total, change, percentageMode);
                    twitterDataPoint = SocialReachChartDataFormattingService.calculateDataPoint(SocialReachChartDataFormattingService.sourceSettings.Twitter, totalTwitterCount, index, epochMoment, total, change, percentageMode);
                    facebookDataPoint = SocialReachChartDataFormattingService.calculateDataPoint(SocialReachChartDataFormattingService.sourceSettings.Facebook, totalFacebookCount, index, epochMoment, total, change, percentageMode);

                    if(youtubeDataPoint) {
                        youtubeData.data.push(youtubeDataPoint);
                    }
                    if(twitterDataPoint) {
                        twitterData.data.push(twitterDataPoint);
                    }
                    if(facebookDataPoint) {
                        facebookData.data.push(facebookDataPoint);
                    }

                    previousTotal = total;
                    index++;
                }

                seriesArray = [
                    youtubeData,
                    twitterData,
                    facebookData,
                    SocialReachChartDataFormattingService.sourceSettings.YouTube,
                    SocialReachChartDataFormattingService.sourceSettings.Twitter,
                    SocialReachChartDataFormattingService.sourceSettings.Facebook,
                ];

                return {
                    credits: {
                        enabled: false
                    },
                    exporting: {
                        enabled: false
                    },
                    title: {
                        text: null
                    },
                    chart: {
                        zoomType: '',
                        spacingLeft: 0,
                        marginRight: 1,
                        type: 'column'
                    },
                    tooltip: {
                        borderRadius: 4,
                        backgroundColor: 'rgba(255,255,255,.85)',
                        hideDelay: 0,
                        formatter: tooltipHandler
                    },
                    xAxis: this.getXAxisConfigs(scope.isMaximized, scope.labelVisibility, percentageMode, tickPositions, dateCategories, totalArray),
                    yAxis: {
                        min: (!percentageMode) ? 1 : null,
                        max: (percentageMode) ? 100 : null,
                        type: chartType,
                        lineColor: '#eee',
                        lineWidth: 1,
                        minorTickInterval: 0.01,
                        title: {
                            text: percentageMode ?
                                translationService.getLocalizedString('Percentage') :
                                translationService.getLocalizedString('social-reach-widget__graph-yaxis--reach')
                        },
                        gridLineColor: '#eee',
                        labels: {
                            formatter: function () {
                                if(percentageMode) {
                                    return SocialReachChartDataFormattingService.formatPercentageDataLabels(this.value);
                                } else {
                                    return SocialReachChartDataFormattingService.formatYAxisDataLabels(this.value);
                                }
                            }
                        }
                    },
                    plotOptions: {
                        series: {
                            cursor: 'pointer',
                            marker: {
                                symbol: 'circle',
                                radius: 5,
                                lineWidth: 0,
                                lineColor: '#ffffff'
                            },
                            states: {
                                hover: {
                                    halo: null
                                }
                            },
                            dataLabels: {
                                style: {
                                    color: '#000'
                                },
                                enabled: scope.labelVisibility,
                                formatter: function () {
                                    if (percentageMode) {
                                        return SocialReachChartDataFormattingService.formatPercentageDataLabels(this.point.perc);
                                    } else {
                                        return SocialReachChartDataFormattingService.formatFixedPrecisionDataLabels(this.point.count, scope.isMaximized);
                                    }
                                }
                            },
                            animation: InsWidgetConfigService.getChartAnimationStatus(scope.widget.id + scope.isMaximized),
                            point: {
                                events: {
                                    click: function () {
                                        scope.documentRequest.source = this.source;
                                        if (typeof scope.inputs !== 'undefined') {
                                            scope.internalDrillDown(scope.inputs[0].id, this.date);
                                        } else {
                                            scope.internalDrillDown(scope.searches[0].agent, this.date);
                                        }
                                    }
                                }
                            }
                        }
                    },
                    legend: {
                        enabled: true,
                        borderRadius: 0,
                        borderWidth: 0,
                        symbolPadding: 3,
                        symbolWidth: 8,
                        symbolRadius: 0,
                        itemDistance: 20,
                        margin: 0,
                        x: 12,
                        y: 12,
                        padding: 0,
                        itemStyle: {
                            color: '#808080',
                            fontSize: '11px',
                            fontWeight: 'normal'
                        },
                        itemHoverStyle: {
                            color: '#808080'
                        }
                    },
                    series: seriesArray
                }
            }
        };
    }]);
